var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3327 17.709H1.66602C1.32435 17.709 1.04102 17.9923 1.04102 18.334C1.04102 18.6757 1.32435 18.959 1.66602 18.959H18.3327C18.6744 18.959 18.9577 18.6757 18.9577 18.334C18.9577 17.9923 18.6744 17.709 18.3327 17.709Z",
    fill: "#E8F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.1667 1.66602H5.83333C3.33333 1.66602 2.5 3.15768 2.5 4.99935V18.3327H17.5V4.99935C17.5 3.15768 16.6667 1.66602 14.1667 1.66602Z",
    fill: "#E8F0FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 14.375H5.83398C5.49232 14.375 5.20898 14.0917 5.20898 13.75C5.20898 13.4083 5.49232 13.125 5.83398 13.125H8.33398C8.67565 13.125 8.95898 13.4083 8.95898 13.75C8.95898 14.0917 8.67565 14.375 8.33398 14.375Z",
    fill: "#E8F0FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 14.375H11.666C11.3243 14.375 11.041 14.0917 11.041 13.75C11.041 13.4083 11.3243 13.125 11.666 13.125H14.166C14.5077 13.125 14.791 13.4083 14.791 13.75C14.791 14.0917 14.5077 14.375 14.166 14.375Z",
    fill: "#E8F0FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 10.625H5.83398C5.49232 10.625 5.20898 10.3417 5.20898 10C5.20898 9.65833 5.49232 9.375 5.83398 9.375H8.33398C8.67565 9.375 8.95898 9.65833 8.95898 10C8.95898 10.3417 8.67565 10.625 8.33398 10.625Z",
    fill: "#E8F0FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 10.625H11.666C11.3243 10.625 11.041 10.3417 11.041 10C11.041 9.65833 11.3243 9.375 11.666 9.375H14.166C14.5077 9.375 14.791 9.65833 14.791 10C14.791 10.3417 14.5077 10.625 14.166 10.625Z",
    fill: "#E8F0FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33398 6.875H5.83398C5.49232 6.875 5.20898 6.59167 5.20898 6.25C5.20898 5.90833 5.49232 5.625 5.83398 5.625H8.33398C8.67565 5.625 8.95898 5.90833 8.95898 6.25C8.95898 6.59167 8.67565 6.875 8.33398 6.875Z",
    fill: "#E8F0FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.166 6.875H11.666C11.3243 6.875 11.041 6.59167 11.041 6.25C11.041 5.90833 11.3243 5.625 11.666 5.625H14.166C14.5077 5.625 14.791 5.90833 14.791 6.25C14.791 6.59167 14.5077 6.875 14.166 6.875Z",
    fill: "#E8F0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.b6b9322a9cb2c8e09638284319fe3f50.svg";
export { ForwardRef as ReactComponent };